module.exports = __webpack_public_path__ + "static/media/package_purchase.f30285b7.png";